import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export interface TicketSession {
  id?: number
  timeSlotCode?: string
  timeSlotName?: string
  startTime?: string
  endTime?: string
  timeRange?: string | string[]
  price?: number
  priceText?: string
  enabled: number
  sortOrder: number
}

export interface TicketDetail {
  id?: number
  title: string
  content: string
  sortOrder?: number
}

export interface TicketForm {
  id?: number
  coverImage: string
  exhibitionName: string
  startDate: string
  endDate: string
  sessions: TicketSession[]
  details: TicketDetail[]
  noticeTitle: string
  noticeContent: string
}

export interface TicketListItem {
  id: number
  exhibitionName: string
  startDate: string
  endDate: string
  displayStatus: number
  displayStatusName?: string
  publishStatus?: number
  modifyTime?: string
}

export interface TimeSlotOption {
  code: string
  label: string
  startTime: string
  endTime: string
}

export interface SessionConfig {
  ticketId: number
  exhibitionName: string
  startDate: string
  endDate: string
  originalEndDate: string
  startDateEditable: boolean
  defaultSessions: TicketSession[]
}

export const useTicket = defineStore('ticket', {
  state: () => ({}),
  actions: {
    // 分页查询门票
    async getTicketPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/ticket/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 根据门票ID查询场次列表（含配置模板）
    async getTicketSessionList(ticketId: number | string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/ticketSession/list/${ticketId}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 发布或更新场次配置
    async publishDaySessions(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/ticketSession/publishOrUpdate',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 更新展览日期范围
    async updateDateRange(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/ticketSession/dateRange',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 查询门票详情
    async getTicketInfo(id: number | string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/ticket/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 保存草稿
    async saveTicketDraft(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/ticket/saveDraft',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 发布门票
    async publishTicket(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/ticket/publish',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除门票
    async deleteTicket(id: number | string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/ticket/del',
          method: 'post',
          data: { id }
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 字典查询（时段选项等）
    async getDict(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/dict',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
